import React from 'react';
import styles from './LogsList.module.scss';

export interface LogItemProps {
  timestamp?: string;
  message?: string;
  level?: 'info' | 'warning' | 'error' | 'success';
  source?: string;
}

export default function LogItem({ timestamp, message, level, source }: LogItemProps) {
  const formatTimestamp = (timestamp: string) => {
    const date = new Date(timestamp);
    return date.toLocaleString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };



  return (
    <div className={styles.logEntry}>
      <div className={styles.logHeader}>
        {timestamp && (
        <span className={styles.timestamp}>{formatTimestamp(timestamp)}</span>
        )}
        {level && (
          <span className={styles.level}>{level}</span>
        )}
        {source && (
          <span className={styles.source}>{source}</span>
        )}
      </div>
      <div className={styles.logMessage}>
        {message}
      </div>
    </div>
  );
}
